import React from 'react';

export const EmptyState = ({
  icon = null,
  title,
  description,
  action = null,
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-12 text-center ${className}`}>
      {icon && (
        <div className="text-slate-300 mb-4">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-slate-700 mb-2">
        {title}
      </h3>
      <p className="text-slate-500 mb-6 max-w-md">
        {description}
      </p>
      {action && (
        <div>
          {action}
        </div>
      )}
    </div>
  );
};
